/**
 * Accords en français, pour cesser d'écrire « 1 commande(s) ».
 *
 * La parenthèse est une facilité d'écriture qui se voit : sur un tableau de
 * bord lu tous les matins, « 3 · 1 urgents » et « 0 facture(s) en retard »
 * donnent le sentiment d'un outil inachevé. Le nombre est toujours connu au
 * moment de l'affichage — il n'y a aucune raison de laisser le lecteur faire
 * l'accord lui-même.
 *
 * En français, le singulier vaut aussi pour zéro : « 0 commande », « 1
 * commande », « 2 commandes ».
 */
export function pluriel(nombre: number, singulier: string, plurielForce?: string): string {
	const forme = Math.abs(nombre) >= 2 ? (plurielForce ?? `${singulier}s`) : singulier;
	return `${nombre.toLocaleString('fr-FR')} ${forme}`;
}

/**
 * L'accord seul, sans le nombre — quand le chiffre est déjà affiché à part,
 * en gros caractères par exemple.
 */
export function accord(nombre: number, singulier: string, plurielForce?: string): string {
	return Math.abs(nombre) >= 2 ? (plurielForce ?? `${singulier}s`) : singulier;
}
